import * as React from "react";
import { InputWithAlert } from "../ui/input-with-alert";
import { formatDateString } from "@/styles";
import { useTranslation } from "react-i18next";

export const DocumentZgloszenieUKR = (props) => {
  const { document } = props;
  const { t } = useTranslation();
  const { entityType, createdAt, status } = document;
  const { zgloszenie_type } = document.metadata;

  return (
    <div className="w-full">
      <div className="pt-6">
        <InputWithAlert
          label={t("document_type")}
          disabled={true}
          type="text"
          value={entityType}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("created_at")}
          disabled={true}
          type="text"
          value={formatDateString(createdAt)}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("oswiadczenie_type")}
          disabled={true}
          type="text"
          value={zgloszenie_type.value}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>

      <div className="pt-6">
        <InputWithAlert
          label={t("status")}
          disabled={true}
          type="text"
          value={status}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
    </div>
  );
};
